import React from "react";

import { CategoriaDeAlumno } from "../../../../services/v2/classPortal.service";

/*
	Piezas que comparten el Libro De Notas (personal) y Mis Notas (alumno), Parte C. Las cifras las calcula SOLO el servidor
	(LmsNotasService); aquí solo se muestran. Bajo la nota mínima (70) va en oro, nunca en rojo.
*/

/** Promedios con un decimal como mucho: 82.35 → "82.4", 90 → "90". */
export const notaTxt = (n: number | null | undefined): string => (n === null || n === undefined ? "–" : String(Math.round(n * 10) / 10))

/** Igual que el servidor: se compara lo que se ve (un decimal), así 69.96 se ve 70 y no se pinta. */
export const esBaja = (n: number | null | undefined, minimo: number): boolean => n !== null && n !== undefined && Math.round(n * 10) / 10 < minimo

export const pesoTxt = (n: number): string => String(Math.round(n * 100) / 100) + " %"

/** Barra de una categoría: nombre, peso y su %; "Sin Notas Aún" mientras nada cuente (su peso se reparte entre las demás). */
export const BarraCategoria: React.FC<{ c: CategoriaDeAlumno; minimo: number; asistenciaTxt?: string | null }> = ({ c, minimo, asistenciaTxt }) => {
	const baja = esBaja(c.pct, minimo)
	return (
		<div className="ntBarraCat">
			<div>
				<span>{c.name} <small>· {pesoTxt(c.weight)}</small></span>
				<span className={baja ? "ntOro" : undefined}>{c.pct === null ? <small>Sin Notas Aún</small> : notaTxt(c.pct)}</span>
			</div>
			<div className="ntRiel" role="img" aria-label={c.name + ": " + (c.pct === null ? "sin notas aún" : notaTxt(c.pct) + " de 100")}>
				<div className={baja ? "ntRielOro" : undefined} style={{ width: Math.max(0, Math.min(100, c.pct || 0)) + "%" }} />
			</div>
			{asistenciaTxt ? <small style={{ display: "block", marginTop: 4 }}>{asistenciaTxt}</small> : null}
		</div>
	)
}

/** "Asistió 11 De 12 Clases" (solo clases pasadas, no canceladas, con asistencia tomada). */
export const textoAsistencia = (a: { present: number; total: number }): string | null =>
	a.total > 0 ? "Asistió " + a.present + " De " + a.total + (a.total === 1 ? " Clase" : " Clases") : null
